// extracted by mini-css-extract-plugin
export default {"account-item":"AccountItem_account-item__oJri-"};